import { Link } from '@billy/design-system'
import { ReactNode } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { PeriodMode } from '../../../../../../../../enums/periodMode'
import { useQuotesList } from '../../../../context/quotesList'
import { useQuotesListData } from '../../../../context/quotesListData'
import { useQuotesListFilters } from '../../../../context/quotesListFilters'

export const QuotesTableEmptyRowInfo = (): ReactNode => {
  const { t } = useTranslation()
  const { hasQuotes } = useQuotesListData()
  const { newDocumentUrl } = useQuotesList()
  const [filters] = useQuotesListFilters()

  if (!hasQuotes) {
    return <Trans i18nKey="external_invoices.quotes_list.empty_state" components={[<Link to={newDocumentUrl} />]} />
  }

  if (filters.searchQuery) {
    return t('external_invoices.quotes_list.no_results.search')
  }

  if (filters.period && filters.period !== PeriodMode.All) {
    return t('external_invoices.quotes_list.no_results.period')
  }

  return t('table.empty_message')
}
